import PickupDisplay from '@/api/pickup-display'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  devices: [],
  click_close: false
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DEVICES(state, date) {
    state.devices = date
  },
  SET_CLICK_CLOSE(state, data) {
    state.click_close = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return PickupDisplay.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  setting(context, data) {
    return PickupDisplay.setting(data)
  },
  acknowledge(context, data) {
    return PickupDisplay.acknowledge(data)
  },
  priorityCall(context, data) {
    return PickupDisplay.priorityCall(data)
  },
  getStudent(context, data) {
    return PickupDisplay.getStudent(data)
  },
  dataBeforeCreate(context) {
    return PickupDisplay.getPreData().then(response => {
      context.commit('SET_DEVICES', response.devices)
      return Promise.resolve(response)
    })
  }
}
